export const defaultComponentsOrderForPF = {
  OfferPartnerFormContainer: 10,
  OfferPartnerIncomeTypeContainer: 20,
  OfferPartnerMonthlyObligationsContainer: 30,
  OfferPartnerContactPersonsContainer: 40,
  OfferPartnerContactInfoContainer: 50,
  OfferPartnerBankAccountContainer: 60,
  OfferPartnerPropertyContainer: 70,
  OfferPartnerConsentContainer: 80,
  OfferPartnerListQuestionnaireContainer: 90,
  PartnerRelationsContainer: 100,
  OfferPartnerVerificationContainer: 110,
  DocumentPartnerExtraInformationContainer: 120
};

export const defaultComponentsOrderForPFA = {
  OfferPartnerFormContainer: 10,
  OfferPartnerIncomeTypeContainer: 20,
  OfferPartnerContactPersonsContainer: 30,
  OfferPartnerContactInfoContainer: 40,
  OfferPartnerBankAccountContainer: 50,
  OfferPartnerShareholderContainer: 60,
  OfferPartnerActivityFieldsContainer: 70,
  OfferPartnerPropertyContainer: 80,
  OfferPartnerConsentContainer: 90,
  OfferPartnerListQuestionnaireContainer: 100,
  OfferPartnerVerificationContainer: 110,
  DocumentPartnerExtraInformationContainer: 120
};

export const defaultComponentsOrderForPJ = {
  OfferPartnerFormContainer: 10,
  OfferPartnerContactPersonsContainer: 20,
  OfferPartnerContactInfoContainer: 30,
  OfferPartnerBankAccountContainer: 40,
  OfferPartnerShareholderContainer: 50,
  OfferPartnerActivityFieldsContainer: 60,
  OfferPartnerPropertyContainer: 70,
  OfferPartnerConsentContainer: 80,
  OfferPartnerListQuestionnaireContainer: 90,
  OfferPartnerVerificationContainer: 100,
  DocumentPartnerExtraInformationContainer: 110
};
